<template>
    <v-container fluid fill-height>
        <v-card  outlined width="100%" class="fill-height">
            <v-card-text class="pa-5">
                <v-row>
                    <v-col cols=6 md=6 lg=6 sm=6>
                        <v-chip label color="amber"> <v-icon left>mdi-account-multiple</v-icon>User Manager</v-chip>
                    </v-col>
                    <v-col cols=6 md=6 lg=6 sm=6 style="postion:relative">
                        <v-speed-dial v-model="fab" direction="left" :open-on-hover="false" 
                        transition="slide-y-reverse-transition" class="Speed-button-Setting">
                            <template v-slot:activator>
                                <v-btn v-model="fab" color="amber" fab class="elevation-0">
                                <v-icon v-if="fab">mdi-close</v-icon>
                                <v-icon v-else>mdi-account-multiple</v-icon>
                                </v-btn>
                            </template>
                            <v-btn fab dark small color="indigo" @click="CreateBox = true"><v-icon>mdi-plus</v-icon></v-btn>
                            <v-btn v-if="selection.length > 0" fab dark small color="red" @click="deleteBox=true">
                                <v-icon>mdi-delete</v-icon>
                            </v-btn>
                        </v-speed-dial>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols=12 md=12 lg=12 sm=12>
                        <v-card flat>
                            <v-card-title>
                                <v-spacer></v-spacer>
                                <v-text-field v-model="search" outlined
                                color="amber" append-icon="mdi-magnify" dense
                                 label="Search" hide-details></v-text-field>
                            </v-card-title>
                            <v-data-table :headers="headers" :items="records" :search="search" v-model="selection" :show-select="role =='admin' ? true : false">
                                <template v-slot:item.product="{ item }" >
                                    <span v-for="(data, i) in item.productData" :key="i">
                                        <v-chip class='ma-1 text-lowercase' label x-small color="blue-grey lighten-4" text>{{data.name}}</v-chip><br>
                                    </span>
                                </template>
                                <template v-slot:item.status="{ item }">
                                        <v-chip class='ma-1' label x-small :color="item.status == 1 ? 'green' : 'red'" dark @click="statusUpdate(item.status, item.id)">{{item.status == 1 ? 'Active' : 'In Active'}}</v-chip>
                                </template>
                                <template v-slot:item.action="{ item }">
                                    <v-btn color="amber" fab small class="elevation-0" @click="EditBox = true; userId=item.id"><v-icon color="black">mdi-pencil</v-icon></v-btn>
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-col>
                </v-row> 
            </v-card-text>           
        </v-card>
        <v-dialog v-model="CreateBox" fullscreen hide-overlay transition="dialog-bottom-transition">
            <User :edit="false" @Response="action($event)" @Close="CreateBox = false"></User>
        </v-dialog>
        <v-dialog v-model="EditBox" fullscreen hide-overlay transition="dialog-bottom-transition">
            <User :edit="true" :id='userId' @Response="action($event)" @Close="EditBox = false"></User>
        </v-dialog>
        <v-dialog v-model="deleteBox" scrollable persistent max-width="500px" transition="dialog-transition">
            <delConfirm :url="delUrl" :selectedId="deleteconveter" ></delConfirm>
        </v-dialog>
        <v-snackbar v-model="notificationBar" :timeout="10000" top center :color="notificationColor" multi-line> {{ notificationText }}
            <v-btn color="amber" text @click="notificationBar = false"> Close </v-btn>
        </v-snackbar>
    </v-container>
</template>
<script>
import User from '../../components/user/index'
import { SERVER_API } from '../../API';
import delConfirm from '../../components/confirmation/index.vue'
import {bus} from '../../main'
import {store} from '../../store'
export default {
    components:{User,delConfirm},
    mounted(){
        this.fetchall();
    },
    computed:{
        deleteconveter(){
            var deleteId = [...new Set(this.selection.map(it => it.id))];
            return deleteId.toString();
        }
    },
    created(){
        bus.$on('close',() =>  {
            this.deleteBox = false;
            this.selection = [];
        });

        bus.$on('deleted', () =>  {
            for(let i = 0; i < this.selection.length; i++){
                if(this.records.indexOf(this.selection[i])!= -1){
                    this.records.splice(this.records.indexOf(this.selection[i]),1);
                }
            }
        });            
    },
    data(){
        return{
            role:store.state.role,
            delUrl:SERVER_API+'/user/delete',
            userId:'',
            EditBox:false,
            CreateBox:false,
            search:'',
            fab:false,
            headers:[
                { text: 'Name', value: 'name' },
                { text: 'Phone', value: 'phone' },
                { text: 'Comapny', value: 'company' },
                { text: 'Username', value: 'username' },
                { text: 'Assigned Product', value: 'product' },
                { text: 'Role', value: 'role' },
                { text: 'Status', value: 'status' },
                { text: 'Action', value: 'action' },
            ],
            records:[],
            deleteBox:false,
            // Selection of Data
            selection:[],
            // Notification Setting
            notificationColor: 'black',
            notificationBar: false,
            notificationText:''
        }
    },
    methods:{
        async statusUpdate(data,id){
            if(data == 1){
                const response =  await this.$http.post(SERVER_API+'/user/status',{
                    id:id,
                    status:0
                });
                this.action(response.data);
            }else{
                const response =  await this.$http.post(SERVER_API+'/user/status',{
                    id:id,
                    status:1
                });
                this.action(response.data);
            }
        },
        async fetchall(){
            const response =  await this.$http.get(SERVER_API+'/user/records');
            this.records = response.data.data;
        },
        action(e){
            if(e.action == true){
                this.notificationColor = 'black';
                this.notificationBar = true;
                this.notificationText = e.message;
                this.fetchall();
                this.CreateBox = false;
                this.EditBox = false;
            }else{
                this.notificationColor = 'red';
                this.notificationBar = true;
                this.notificationText = this.makeMessage(e);
                //console.log(e);
            }
        },
        makeMessage(error){
            if(error.response){
                //return error.response.data.errors;
                var ar = [];
                if(error.response.data.errors){
                    ar.push(error.response.data.errors);
                    var name = ar[0].name !== undefined ? ar[0].name : ' ';
                    var role = ar[0].role !== undefined ?  ar[0].role : ' ';
                    var product = ar[0].product !== undefined ?  ar[0].product : ' ';
                    var password = ar[0].password !== undefined ?  ar[0].password : ' ';
                    var username = ar[0].username !== undefined ?  ar[0].username : ' ';
                    var phone =  ar[0].phone !== undefined ?  ar[0].phone : ' ';
                    var email =   ar[0].email !== undefined ?  ar[0].email : ' ';
                    

                    return name+' '+email+' '+phone+' '+role+' '+product+' '+username+' '+password;
                }else{
                    return error.response.data.message;
                }
            }else{
                return error;
            }
        },
    }

}
</script>

<style>
.Speed-button-Setting{
    position:absolute;
    right:30px;
}
</style>